// extracted by mini-css-extract-plugin
export default {"cont":"index_cont__0pJB7"};